import { ICombination } from '../../AssignResults/Context/AssignResults.context';

export const isStrokeplayOrHorse = ({
  format: {
    format: { prefix }
  }
}: ICombination) => prefix === 'horse' || prefix === 'stroke';
